import * as React from 'react'

import { Popover as PopoverPrimitive } from 'radix-ui'

import { cn } from './cn'

/**
 * Styled Radix Popover. Unlike the old MUI anchorEl API, compose it as:
 *   <Popover><PopoverTrigger asChild>...</PopoverTrigger>
 *     <PopoverContent>...</PopoverContent></Popover>
 */
export const Popover = PopoverPrimitive.Root
export const PopoverTrigger = PopoverPrimitive.Trigger
export const PopoverAnchor = PopoverPrimitive.Anchor

export const PopoverContent = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, sideOffset = 6, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'z-[1400] rounded-xl border border-divider bg-paper p-4 text-text-primary shadow-menu outline-none animate-ps-pop-in',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = 'PopoverContent'
